import { useAttachments } from 'edrolo/domains/attachments/hooks';
import {
  AttachmentParent,
  AttachmentCategory,
} from '../../../../../../../../enums/Attachments';
import { CardAttachments } from 'edrolo/domains/coursePortal/components/CardAttachments';
import PrevNextLinks from '../../../PrevNextLinks';
import urlResolver from 'edrolo/utils/URLResolver';
import TitleDetail from '../../../TitleDetail';
import { Container } from 'edrolo-style-guide';
import s from './styles.scss';
import { utils as u } from 'edrolo-ui';
import cx from 'classnames';
import PT from 'prop-types';
import IPT from 'react-immutable-proptypes';

export const Header = ({
  classId,
  isTeacher,
  exam,
  numQuestions,
  schoolClassCode,
  schoolClassIsTrial,
  schoolClassExpirationDate,
}) => {
  const examId = exam.get('id');

  const { data, isLoading, error } = useAttachments(
    classId,
    AttachmentParent.EXAM,
    examId,
    isTeacher
  );

  if (isLoading || error) {
    return null;
  }

  const attachments = Object.values(data.toJS()) || [];
  const questionSets = attachments.filter(
    (a) => a.category === AttachmentCategory.QUESTION_SET
  );

  return (
    <div className={s.header}>
      <Container wide>
        <div className={s.headerInner}>
          <div className={u.flex}>
            <h1 data-test="question-set-title" className={s.headerTitle}>
              {exam.get('title')}
            </h1>
            {isTeacher && (
              <PrevNextLinks
                classId={classId}
                questionSetId={examId}
                buildUrl={(questionSetId) =>
                  urlResolver.reverse('question-set-index', {
                    classId,
                    examId: questionSetId,
                  })
                }
              />
            )}
          </div>
          <div className={cx(u.flex, u.spaceBetween)}>
            <TitleDetail
              classCode={schoolClassCode}
              numQuestions={numQuestions}
              isTrial={schoolClassIsTrial}
              expirationDate={schoolClassExpirationDate}
            />
            <CardAttachments attachments={questionSets} />
          </div>
        </div>
      </Container>
    </div>
  );
};

Header.propTypes = {
  classId: PT.oneOfType([PT.string, PT.number]).isRequired,
  isTeacher: PT.bool.isRequired,
  exam: IPT.map.isRequired,
  numQuestions: PT.number.isRequired,
  schoolClassCode: PT.string,
  schoolClassIsTrial: PT.bool.isRequired,
  schoolClassExpirationDate: PT.string.isRequired,
};
